export default class Instrumento {
  constructor() {
    this.id = 0;
    this.descricao = "";
    this.fabricante = "";
    this.serie = "";
    this.modelo = "";
    this.capacidade = "";
    this.certificado = "";
    this.calibracao = new Date();
  }
}
